import { render, staticRenderFns } from "./MitAppsPage.vue?vue&type=template&id=71108656&scoped=true"
import script from "./MitAppsPage.vue?vue&type=script&lang=js"
export * from "./MitAppsPage.vue?vue&type=script&lang=js"
import style0 from "./MitAppsPage.vue?vue&type=style&index=0&id=71108656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71108656",
  null
  
)

export default component.exports